import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { createResourceId, parseResourceId } from ".";
import { mapObjectMapValues } from "../../utils";
import { createResourceVariantStoredValidator } from "../resources/SWBaseStoredResourceVariant";
/** @public */ /** @internal */ export const rootResourceVariantStoredVersions = {};
/** @internal */ export const rootResourceVariantStoredMigrations = defineMigrations({});
/** @public */ export function isResourceVariantStored(record) {
    if (!record) return false;
    return record.typeName === "resource_variant_stored";
}
/** @public */ export function isResourceVariantStoredId(id) {
    if (!id) return false;
    return id.startsWith("resource_variant_stored:");
}
export const parseResourceVariantStoredId = (id)=>{
    if (!id) return undefined;
    if (!id.startsWith("resource_variant_stored:")) return undefined;
    const parts = id.replace("resource_variant_stored:", "").split(":");
    const variant = parts.pop();
    if (!variant) return undefined;
    const parsedResourceId = parseResourceId("resource:" + parts.join(":"));
    if (!parseResourceId) return undefined;
    return {
        ...parsedResourceId,
        variant
    };
};
export const createResourceVariantStoredIdPrefix = (type)=>`resource_variant_stored:${type}:`;
export function createResourceVariantStoredId({ type, name, organizationId, scope, variant }) {
    const resourceId = createResourceId({
        type,
        name,
        organizationId,
        scope
    });
    return `resource_variant_stored:${resourceId.replace("resource:", "")}:${variant}`;
}
export function isTextResourceVariantStored(record) {
    return record.type === "text";
}
export const castResourceVariantStored = (record)=>{
    return {
        toVariant () {
            return parseResourceVariantStoredId(record.id)?.variant;
        },
        toResourceId () {
            const parts = record.id.split(":");
            parts.pop();
            return parts.join(":").replace(/^resource_variant_stored:/, "resource:");
        }
    };
};
/** @internal */ export function createResourceVariantStoredRecordType(resource_variants) {
    return createRecordType("resource_variant_stored", {
        migrations: undefined,
        scope: "document",
        validator: T.model("resource_variant_stored", T.union("type", mapObjectMapValues(resource_variants, (type, { props, meta })=>createResourceVariantStoredValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {}
        }));
}
